export default __webpack_public_path__ + "static/media/mist_veiled_mercury_elixir.b92220aa.png";